import React from 'react';
import PropTypes from 'prop-types';
import { round } from 'lodash-es';
import { RatingStars } from 'site-modules/shared/components/rating-stars/rating-stars';
import { Link } from 'site-modules/shared/components/link/link';
import { getPlural } from 'client/utils/plural';
import { VdpPopoverItem } from 'site-modules/shared/components/inventory/vdp-popover-item/vdp-popover-item';
import './dealer-reviews-overall-rating.scss';

/**
 * Shows overall sales rating and number of reviews.
 * @param {number} average
 * @param {number} total
 * @param {string} dealerReviewLink
 * @returns {ReactElement}
 */
export function DealerOverallSalesRating({ average, total, dealerReviewLink = '' }) {
  const roundedNumber = round(average, 1);

  return (
    <div className="dealer-overall-sales-rating mb-1_5">
      <Link to={dealerReviewLink} className="text-decoration-none d-inline-block">
        <span className="d-flex align-items-baseline">
          <span className="fw-medium text-cool-gray-40">Overall sales rating</span>
          <VdpPopoverItem>
            <span>Based on reviews posted in the prior 24 months.</span>
          </VdpPopoverItem>
        </span>
        <span className="d-flex align-items-center">
          <span className="heading-3 pe-0_5 text-cool-gray-20">
            {roundedNumber} <span className="visually-hidden">out of 5 stars</span>
          </span>
          <RatingStars
            rating={average}
            className="text-primary-darker size-24"
            starClass="ms-0"
            hideForScreenReader /* notice we are using hideForScreenReader because we have added 'out of 5 stars' to the "heading-3" span above */
          />
        </span>
        <span className="medium text-cool-gray-50">
          {total} {getPlural('Review', total)}
        </span>
      </Link>
    </div>
  );
}

DealerOverallSalesRating.propTypes = {
  average: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  dealerReviewLink: PropTypes.string,
};
